import { defineComponent as _defineComponent } from 'vue'
import VueApexCharts from 'vue-apexcharts';
import { IDeviceStatusItem } from '@/store/modules/metrics/types';
import Metrics from '@/mixins/Metrics';
import useStore from '@/utils/store/common';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import MetricsHeader from './components/MetricsHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceStatus',
  setup(__props) {

const store = useStore();

const chartOptions = ref({});
const series = ref([] as number[]);

const { t } = useI18n();

onMounted(async () => {
  const metrics: IDeviceStatusItem[] = await store.dispatch('metrics/fetchDeviceStatus');
  const deviceStatus = Metrics.transformDeviceStatusData(metrics);
  deviceStatus.labels.forEach((label, i) => { deviceStatus.labels[i] = t(label).toString(); });
  chartOptions.value = Metrics.getPieChartOptions(deviceStatus);
  series.value = deviceStatus.series;
});

return { __sfc: true,store, chartOptions, series, t, VueApexCharts, MetricsHeader }
}

})